import { flushSync } from 'react-dom';

let running: Animation | undefined;
const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Apply decoded scenery immediately; animate without capturing the entire page. */
export async function changeHomeAppearance(update: () => void): Promise<void> {
  running?.cancel();
  running = undefined;
  // Native view transitions capture both full-page scenes. On WebKit this can
  // block rendering and timers for seconds with large landscape artwork.
  flushSync(update);
  const root = document.getElementById('root');
  if (location.pathname !== '/' || reduced() || !root?.animate) return;
  const animation = root.animate([{ opacity: 0.8 }, { opacity: 1 }], {
    duration: 180,
    easing: 'ease-out',
  });
  running = animation;
  document.documentElement.dataset.homeCrossfade = 'true';
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    await Promise.race([
      animation.finished.catch(() => {}), // A newer appearance cancels this fade.
      new Promise<void>((resolve) => {
        timer = setTimeout(() => { animation.cancel(); resolve(); }, 1000);
      }),
    ]);
  } finally {
    clearTimeout(timer);
    if (running === animation) {
      running = undefined;
      delete document.documentElement.dataset.homeCrossfade;
    }
  }
}

/** Carry the baked entrance's clock across hydration/replacement, without replay. */
export function prepareHomeEntrance(hasServerMarkup: boolean) {
  const html = document.documentElement;
  if (!hasServerMarkup) {
    html.dataset.homeIntro = String(performance.now());
    setTimeout(() => { delete html.dataset.homeIntro; }, 5500);
  }
  if (html.dataset.homeIntro) {
    html.style.setProperty('--home-intro-elapsed', `${performance.now() - Number(html.dataset.homeIntro)}ms`);
  }
}

